import { useQuery, useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import axios from "axios";

export const getLists = async ({
  include_archived,
}: {
  include_archived: boolean;
}): Promise<List[]> => {
  const endpoint = `https://api.momentumsolar.io/cdk-collections/v2/lists${!include_archived ? "?end_utc=null" : ""}`;
  const res = await axios.get(endpoint);
  return res.data.data;
};

export const useLists = ({include_archived=false}:{include_archived: boolean}) => {
  return useQuery({
    queryKey: ["contact-lists", include_archived],
    queryFn: () => getLists({include_archived}),
  });
};

export const useArchivedLists = () => {
  return useQuery({
    queryKey: ["contact-lists-archived"],
    queryFn: () => getLists({include_archived: true}),
  });
};

const postCreateList = async (body: PostListBody) => {
  const endpoint = "/cdk-collections/v2/lists";
  console.log("body", body)
  const res = await axios.post(endpoint, body);
  return res.data;
};

export const useCreateListMutation = (options?: UseMutationOptions<void, Error, PostListBody>) => {
  const queryClient = useQueryClient();
  return useMutation<void, Error, PostListBody>({
    mutationFn: postCreateList,
    ...options,
    onSuccess: (...args) => {
      // Internal behavior
      queryClient.invalidateQueries({
        queryKey: ["contact-lists"],
        exact: false,
      });

      queryClient.invalidateQueries({
        queryKey: ["contact-lists-archived"],
        exact: false,
      });

      queryClient.invalidateQueries({
        queryKey: ["contact-lists-with-agents"],
      });

      // Call the user-passed onSuccess if it exists
      options?.onSuccess?.(...args);
    },
  });
};

const deleteList = async ({list_id}: DeleteListPostBody) => {
  const endpoint = `/cdk-collections/v2/lists/${list_id}`;
  const res = await axios.delete(endpoint);
  return res.data;
};

export const useDeleteListMutation = (options?: UseMutationOptions<void, Error, DeleteListPostBody>) => {
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteListPostBody>({
    mutationFn: deleteList,
    ...options,
    onSuccess: (...args) => {
      // Internal behavior
      queryClient.invalidateQueries({
        queryKey: ["contact-lists"],
        exact: false,
      });

      queryClient.invalidateQueries({
        queryKey: ["contact-lists-archived"],
        exact: false,
      });

      queryClient.invalidateQueries({
        queryKey: ["contact-lists-with-agents"],
      });

      // Call the user-passed onSuccess if it exists
      options?.onSuccess?.(...args);
    },
  });
};